import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LandingPageBlock } from '../../../models/cms-models';

@Component({
  selector: 'cms-landing-page-code-block-editor',
  imports: [CommonModule, FormsModule],
  templateUrl: './landing-page-code-block-editor.html',
  styleUrl: './landing-page-block-editor-fields.css',
})
export class LandingPageCodeBlockEditorComponent {
  @Input({ required: true }) block!: LandingPageBlock;
  @Output() blockChange = new EventEmitter<Partial<LandingPageBlock>>();

  updateCodeLanguage(value: string): void {
    this.blockChange.emit({ codeLanguage: value });
  }

  updateCodeContent(value: string): void {
    this.blockChange.emit({ codeContent: value });
  }
}
